export const DATES = {
  TREE_COVER_LOSS: {
    min: 2001,
    max: 2024,
  },
};
